// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_achievement__14eHB {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 9999;
  padding: 20px;
}

.style_sunshine__MtFsB {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 350px;
  z-index: 2;
}
@media screen and (min-height: 600px) {
  .style_sunshine__MtFsB {
    height: 450px;
  }
}
.style_sunshine__MtFsB img {
  width: 100%;
  height: 100%;
}

.style_coin__vdLXf {
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 200px;
  height: 200px;
  z-index: 4;
}
@media screen and (min-height: 600px) {
  .style_coin__vdLXf {
    height: 250px;
  }
}
.style_coin__vdLXf img {
  width: 100%;
  height: 100%;
}

.style_cloud__left__\\+E-UW {
  position: absolute;
  top: 35%;
  left: 25%;
  transform: translate(-50%, -50%);
  width: 144px;
  height: 154px;
  z-index: 2;
}
.style_cloud__left__\\+E-UW img {
  width: 100%;
  height: 100%;
}

.style_cloud__right__\\+mw5H {
  position: absolute;
  top: 35%;
  left: 65%;
  transform: translate(-50%, -50%);
  width: 259px;
  height: 135px;
  z-index: 2;
}
.style_cloud__right__\\+mw5H img {
  width: 100%;
  height: 100%;
}

.style_cloud__middle__38\\+5c {
  position: absolute;
  top: 44%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 158px;
  z-index: 4;
  display: flex;
  justify-content: center;
}
.style_cloud__middle__image__sQGqA {
  margin-left: 35px;
  width: 300px;
  height: 100%;
}
@media screen and (min-height: 600px) {
  .style_cloud__middle__38\\+5c {
    top: 44%;
  }
}

.style_cloud__middle__content__4vMXm {
  position: relative;
}

.style_text__hnO8Q {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: rgb(117, 83, 240);
}
.style_text__title__F\\+qzE {
  font-weight: 500;
  font-size: 1.4rem;
  color: rgb(117, 83, 240);
}
.style_text__exp__hjzub {
  font-weight: 700;
  font-size: 1.6rem;
  color: rgb(117, 83, 240);
}

.style_action__VEfuG {
  width: 80vw;
  position: absolute;
  top: 90%;
}

.style_text__amount__lqxMe {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  color: rgb(117, 83, 240);
}
.style_text__amount__text__m1WtV {
  color: rgb(117, 83, 240);
  font-size: 2.8rem;
  font-weight: 800;
}
.style_text__amount__lqxMe img {
  width: 24px;
  height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/achievement/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCCHM;EDIN,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;AADF;;AAIA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AADF;AAEE;EARF;IASI,aAAA;EACF;AACF;AAAE;EACE,WAAA;EACA,YAAA;AAEJ;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;AACF;AAAE;EARF;IASI,aAAA;EAGF;AACF;AAFE;EACE,WAAA;EACA,YAAA;AAIJ;;AAAA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;AAGF;AAFE;EACE,WAAA;EACA,YAAA;AAIJ;;AAAA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;AAGF;AAFE;EACE,WAAA;EACA,YAAA;AAIJ;;AAAA;EACE,kBAAA;EACA,QAAA;EACA,gCAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;AAGF;AAFE;EACE,iBAAA;EACA,YAAA;EACA,YAAA;AAIJ;AAFE;EAdF;IAeI,QAAA;EAKF;AACF;;AAFA;EACE,kBAAA;AAKF;;AAFA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBC9GK;ADmHP;AAJE;EACE,gBAAA;EACA,iBAAA;EACA,wBClHG;ADwHP;AAHE;EACE,gBAAA;EACA,iBAAA;EACA,wBCxHG;AD6HP;;AADA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;AAIF;;AADA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,wBCvIK;AD2IP;AAHE;EACE,wBCzIG;ED0IH,iBAAA;EACA,gBAAA;AAKJ;AAHE;EACE,WAAA;EACA,YAAA;AAKJ","sourcesContent":["@import 'public/assets/colors';\n\n.achievement {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: $white;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 9999;\n  padding: 20px;\n}\n\n.sunshine {\n  position: absolute;\n  top: 30%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 350px;\n  z-index: 2;\n  @media screen and (min-height: 600px) {\n    height: 450px;\n  }\n  img {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.coin {\n  position: absolute;\n  top: 25%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 200px;\n  height: 200px;\n  z-index: 4;\n  @media screen and (min-height: 600px) {\n    height: 250px;\n  }\n  img {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.cloud__left {\n  position: absolute;\n  top: 35%;\n  left: 25%;\n  transform: translate(-50%, -50%);\n  width: 144px;\n  height: 154px;\n  z-index: 2;\n  img {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.cloud__right {\n  position: absolute;\n  top: 35%;\n  left: 65%;\n  transform: translate(-50%, -50%);\n  width: 259px;\n  height: 135px;\n  z-index: 2;\n  img {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.cloud__middle {\n  position: absolute;\n  top: 44%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 158px;\n  z-index: 4;\n  display: flex;\n  justify-content: center;\n  &__image {\n    margin-left: 35px;\n    width: 300px;\n    height: 100%;\n  }\n  @media screen and (min-height: 600px) {\n    top: 44%;\n  }\n}\n\n.cloud__middle__content {\n  position: relative;\n}\n\n.text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 9999;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: $main;\n  &__title {\n    font-weight: 500;\n    font-size: 1.4rem;\n    color: $main;\n  }\n\n  &__exp {\n    font-weight: 700;\n    font-size: 1.6rem;\n    color: $main;\n  }\n}\n\n.action {\n  width: 80vw;\n  position: absolute;\n  top: 90%;\n}\n\n.text__amount {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 6px;\n  color: $main;\n  &__text {\n    color: $main;\n    font-size: 2.8rem;\n    font-weight: 800;\n  }\n  img {\n    width: 24px;\n    height: 24px;\n  }\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"achievement": `style_achievement__14eHB`,
	"sunshine": `style_sunshine__MtFsB`,
	"coin": `style_coin__vdLXf`,
	"cloud__left": `style_cloud__left__+E-UW`,
	"cloud__right": `style_cloud__right__+mw5H`,
	"cloud__middle": `style_cloud__middle__38+5c`,
	"cloud__middle__image": `style_cloud__middle__image__sQGqA`,
	"cloud__middle__content": `style_cloud__middle__content__4vMXm`,
	"text": `style_text__hnO8Q`,
	"text__title": `style_text__title__F+qzE`,
	"text__exp": `style_text__exp__hjzub`,
	"action": `style_action__VEfuG`,
	"text__amount": `style_text__amount__lqxMe`,
	"text__amount__text": `style_text__amount__text__m1WtV`
};
export default ___CSS_LOADER_EXPORT___;
